"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userInteractionAssessmentsArraySchema = exports.UserInteractionAssessmentTypeSchema = exports.userInteractionCompleteAssessmentSchema = exports.userInteractionAnswerAssessmentSchema = exports.userInteractionNativeAssessmentSchema = exports.userInteractionPronunciationAssessmentSchema = exports.userInteractionGrammarAssessmentSchema = exports.grammarInteractionError = void 0;
const zod_1 = require("zod");
const enums_1 = require("./enums");
const grammar_1 = require("./grammar");
const pronunciation_1 = require("./pronunciation");
exports.grammarInteractionError = zod_1.z.object({
    type: grammar_1.grammarErrorSchema,
    originalWord: zod_1.z.string(),
    correctWord: zod_1.z.string(),
    sentence: zod_1.z.string(),
    sentenceCorrected: zod_1.z.string(),
    replaceStartAt: zod_1.z.number(),
    replaceEndAt: zod_1.z.number(),
    correctAudioURL: zod_1.z.string(),
    explanation: zod_1.z.string(),
    examples: zod_1.z
        .array(zod_1.z.object({
        sentence: zod_1.z.string(),
    }))
        .length(1),
});
exports.userInteractionGrammarAssessmentSchema = zod_1.z.object({
    score: zod_1.z.number(),
    original: zod_1.z.string(),
    corrected: zod_1.z.string(),
    errors: zod_1.z.array(exports.grammarInteractionError),
});
exports.userInteractionPronunciationAssessmentSchema = zod_1.z.object({
    wordsCount: zod_1.z.number(),
    words: zod_1.z.array(pronunciation_1.pronunciationWordSchema),
    phonemes: zod_1.z.array(pronunciation_1.pronunciationPhonemeSchema),
    phonemesMistakesCount: zod_1.z.number(),
    phonemesMistakes: zod_1.z.array(pronunciation_1.pronunciationPhonemeSchema),
    wordsMistakesCount: zod_1.z.number(),
    wordsMistakes: zod_1.z.array(pronunciation_1.pronunciationWordSchema),
    score: zod_1.z.number(),
    imageURL: zod_1.z.string().nullish(),
    resultURL: zod_1.z.string().nullish(),
    audioURL: zod_1.z.string().nullish(),
});
exports.userInteractionNativeAssessmentSchema = zod_1.z.object({
    isCorrect: zod_1.z.boolean(),
    score: zod_1.z.number(),
    original: zod_1.z.string(),
    corrected: zod_1.z.string(),
    explanation: zod_1.z.string().nullish(),
    imageURL: zod_1.z.string().nullish(),
});
exports.userInteractionAnswerAssessmentSchema = zod_1.z.object({
    score: zod_1.z.number(),
    userAnswer: zod_1.z.string(),
    correctAnswer: zod_1.z.string(),
});
exports.userInteractionCompleteAssessmentSchema = zod_1.z.object({
    score: zod_1.z.number(),
    grammar: exports.userInteractionGrammarAssessmentSchema.nullable(),
    pronunciation: exports.userInteractionPronunciationAssessmentSchema.nullable(),
    native: exports.userInteractionNativeAssessmentSchema.nullable(),
});
exports.UserInteractionAssessmentTypeSchema = zod_1.z.nativeEnum(enums_1.UserInteractionAssessmentType);
exports.userInteractionAssessmentsArraySchema = zod_1.z.array(zod_1.z.union([
    zod_1.z.object({
        kind: zod_1.z.literal(exports.UserInteractionAssessmentTypeSchema.enum.GRAMMAR),
        payload: exports.userInteractionGrammarAssessmentSchema,
    }),
    zod_1.z.object({
        kind: zod_1.z.literal(exports.UserInteractionAssessmentTypeSchema.enum.PRONUNCIATION),
        payload: exports.userInteractionPronunciationAssessmentSchema,
    }),
    zod_1.z.object({
        kind: zod_1.z.literal(exports.UserInteractionAssessmentTypeSchema.enum.NATIVE),
        payload: exports.userInteractionNativeAssessmentSchema,
    }),
    zod_1.z.object({
        kind: zod_1.z.literal(exports.UserInteractionAssessmentTypeSchema.enum.ANSWER),
        payload: exports.userInteractionAnswerAssessmentSchema,
    }),
]));
//# sourceMappingURL=userInteractionAssessment.js.map